import { getDefaultOutlookSpacesService, OutlookSpacesOwsClient } from 'owa-timestream-service';
import type { NewOutlookSpace } from 'owa-timestream-types';
import { timeStreamProjectCreated } from '../actions';

export default async function createTimeStreamProject(
    targetMailbox: string,
    newProject: NewOutlookSpace
) {
    const service = !!targetMailbox
        ? new OutlookSpacesOwsClient(targetMailbox)
        : getDefaultOutlookSpacesService();

    const newOutlookSpace = await service.createOutlookSpace(newProject);
    timeStreamProjectCreated(targetMailbox, newOutlookSpace);
}
